<template>
    <div>
        <hos_apply_title title="申请医生信息"></hos_apply_title>
        <el-form :model="detail" class="mt10" label-position="left" size="mini">
            <el-form-item label="申请医院:" label-width="80px" class="marginBottom">
                {{detail.initHosName}}
            </el-form-item>
            <el-form-item label="申请科室:" label-width="80px" class="marginBottom">
                {{detail.initDeptName}}
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="申请医生:" label-width="80px" class="marginBottom">
                        {{detail.initDocName}}
                    </el-form-item>
                </el-col>
                <el-col :span="10" :push="2">
                    <el-form-item label="联系电话:" label-width="80px" class="marginBottom">
                        {{detail.docTelphone || ''}}
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import hos_apply_title from './hos-apply-title'
    export default {
        name: "hos-doc-info-detail",
        components:{
            hos_apply_title
        },
        props:{
            detail:{
                type:Object
            }
        },
        data(){
            return{

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/hos";
</style>